import { productTranslations } from '../utilities'

export function contributorsList (contributors) {
  const authorsObj = {}
  const roles = {}
  const productDetailsWrapper = document.getElementById('products-details-wrapper')

  if (contributors && contributors.length && contributors[0].role) {
    contributors.sort(function (a, b) {
      return (parseInt(a.order) > parseInt(b.order)) ? 1 : ((parseInt(b.order) > parseInt(a.order) ? -1 : 0))
    })
    contributors.forEach(function (contributor) {
      roles[contributor.role.code] = contributor.role.name
    })

    contributors.forEach(function (contributor) {
      if (!contributor.role || !contributor.contributor) {
        return
      }

      let role = contributor.role.code
      const { name } = contributor.contributor
      const contributorID = contributor.contributor_id
      let vendor = ''
      if (window.theme.productData && window.theme.productData.vendor) vendor = window.theme.productData.vendor

      for (const rolesKey in roles) {
        if (role === rolesKey) {
          role = roles[rolesKey]
        }
      }

      if (!Object.prototype.hasOwnProperty.call(authorsObj, role)) {
        authorsObj[role] = []
      }

      let authorLinks = `<a href="/collections/vendors?q=${vendor || name}&contributorID=${contributorID}" title="${name}">${name}</a>`

      if (productDetailsWrapper && window.theme.settings.showBookDetails && window.theme.settings.showBookDetails.show_author_links === false) {
        authorLinks = name
      }

      authorsObj[role].push(authorLinks)
    })
  }

  if (authorsObj) {
    return contributorsDisplay(authorsObj)
  } else {
    return ''
  }
}

export function contributorsDisplay (contributors) {
  const authorsListArray = []
  let contributorsArray = []
  // get author labels for translations
  const translationsObj = productTranslations()
  let roleName = ''

  for (const roles in contributors) {
    roleName = roles
    // create object keys to return the right role translated
    const roleCode = roles.replaceAll(' ', '_').replace(/[{()}]/g, '').toLowerCase()
    // assign translated role label only if exists in the JSON
    if (translationsObj[roleCode]) {
      roleName = translationsObj[roleCode]
    }

    const and = translationsObj.and || 'and'

    // contributor label html
    const roleLabel = `<span>${roleName}</span>`

    // split the array if length > 5 and apply read more
    if (contributors[roles].length > 5) {
      contributorsArray = [contributors[roles].slice(0, 5), contributors[roles].slice(5)]
      if (contributorsArray[1]) {
        authorsListArray.push(`<span class="product-contributors">${roleLabel} ${contributorsArray[0].join(', ')},<button class="js-read-more">See more</button>`)
        if (contributorsArray[1].length >= 2) {
          const lastContributor = contributors[roles].pop()
          authorsListArray.push(`<span class="hide js-other-contributors">${contributorsArray[1].join(', ')} ${and} ${lastContributor}</span></span>`)
        } else {
          authorsListArray.push(`<span class="hide js-other-contributors">${contributorsArray[1].join(', ')}</span></span>`)
        }
      }
    } else if (contributors[roles].length > 1) {
      const lastContributor = contributors[roles].pop()
      authorsListArray.push(`<span class="product-contributors">${roleLabel} ${contributors[roles].join(', ')} ${and} ${lastContributor}</span>`)
    } else {
      authorsListArray.push(`<span class="product-contributors">${roleLabel}  ${contributors[roles].join(', ')}</span>`)
    }
  }
  return authorsListArray
}
